//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The base contingent model
* 
* @param beginsAt the date and time of the begin (can be different than the event begin)
* @param id the unique contingent id
* @param title the contingent title
* @param doorsOpenAt the date and time of doors open
* @param endsAt the date and time of the end
*/
@Serializable

data class Contingent (


      /* the date and time of the begin (can be different than the event begin) */
    @SerialName(value = "beginsAt") @Required val beginsAt: kotlin.time.Instant,


      /* the unique contingent id */
    @SerialName(value = "id") @Required val id: kotlin.Int,


      /* the contingent title */
    @SerialName(value = "title") @Required val title: kotlin.String,


      /* the date and time of doors open */
    @SerialName(value = "doorsOpenAt") val doorsOpenAt: kotlin.time.Instant? = null,


      /* the date and time of the end */
    @SerialName(value = "endsAt") val endsAt: kotlin.time.Instant? = null


) {




  }

